module.exports = __webpack_public_path__ + "static/media/20160512_185153.441117fc.jpg";